/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EFormePersonneSsLf } from './EFormePersonneSsLf';
import {
    EFormePersonneSsLfFromJSON,
    EFormePersonneSsLfFromJSONTyped,
    EFormePersonneSsLfToJSON,
} from './EFormePersonneSsLf';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { EListSearchTypeEFormePersonneSsLfCombinableCriteria } from './EListSearchTypeEFormePersonneSsLfCombinableCriteria';
import {
    EListSearchTypeEFormePersonneSsLfCombinableCriteriaFromJSON,
    EListSearchTypeEFormePersonneSsLfCombinableCriteriaFromJSONTyped,
    EListSearchTypeEFormePersonneSsLfCombinableCriteriaToJSON,
} from './EListSearchTypeEFormePersonneSsLfCombinableCriteria';

/**
 * 
 * @export
 * @interface EFormePersonneSsLfListSearch
 */
export interface EFormePersonneSsLfListSearch {
    /**
     * 
     * @type {Array<EListSearchTypeEFormePersonneSsLfCombinableCriteria>}
     * @memberof EFormePersonneSsLfListSearch
     */
    criterias?: Array<EListSearchTypeEFormePersonneSsLfCombinableCriteria> | null;
    /**
     * 
     * @type {EListSearchType}
     * @memberof EFormePersonneSsLfListSearch
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {EFormePersonneSsLf}
     * @memberof EFormePersonneSsLfListSearch
     */
    value?: EFormePersonneSsLf;
    /**
     * 
     * @type {EFormePersonneSsLf}
     * @memberof EFormePersonneSsLfListSearch
     */
    secondaryValue?: EFormePersonneSsLf;
    /**
     * 
     * @type {Array<string>}
     * @memberof EFormePersonneSsLfListSearch
     */
    readonly availableSearchTypes?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof EFormePersonneSsLfListSearch
     */
    defaultSearchType?: string | null;
}

/**
 * Check if a given object implements the EFormePersonneSsLfListSearch interface.
 */
export function instanceOfEFormePersonneSsLfListSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EFormePersonneSsLfListSearchFromJSON(json: any): EFormePersonneSsLfListSearch {
    return EFormePersonneSsLfListSearchFromJSONTyped(json, false);
}

export function EFormePersonneSsLfListSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): EFormePersonneSsLfListSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criterias': !exists(json, 'criterias') ? undefined : (json['criterias'] === null ? null : (json['criterias'] as Array<any>).map(EListSearchTypeEFormePersonneSsLfCombinableCriteriaFromJSON)),
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : EFormePersonneSsLfFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : EFormePersonneSsLfFromJSON(json['secondaryValue']),
        'availableSearchTypes': !exists(json, 'availableSearchTypes') ? undefined : json['availableSearchTypes'],
        'defaultSearchType': !exists(json, 'defaultSearchType') ? undefined : json['defaultSearchType'],
    };
}

export function EFormePersonneSsLfListSearchToJSON(value?: EFormePersonneSsLfListSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criterias': value.criterias === undefined ? undefined : (value.criterias === null ? null : (value.criterias as Array<any>).map(EListSearchTypeEFormePersonneSsLfCombinableCriteriaToJSON)),
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': EFormePersonneSsLfToJSON(value.value),
        'secondaryValue': EFormePersonneSsLfToJSON(value.secondaryValue),
        'defaultSearchType': value.defaultSearchType,
    };
}

